import type { SDKPublicAPI } from '../../lib/embed-contracts/public-types'
import { createSDK } from './api/create-sdk'

export interface SDKGlobalAPI extends SDKPublicAPI {
  createSDK: typeof createSDK
  sdk: SDKPublicAPI
}

declare global {
  interface Window {
    __AGENT_SDK__?: SDKGlobalAPI
  }
}

const sdk = createSDK()
const api: SDKGlobalAPI = {
  createSDK,
  sdk,
  mount: sdk.mount.bind(sdk),
  show: sdk.show.bind(sdk),
  hide: sdk.hide.bind(sdk),
  toggle: sdk.toggle.bind(sdk),
  resize: sdk.resize.bind(sdk),
  navigate: sdk.navigate.bind(sdk),
  setExtData: sdk.setExtData.bind(sdk),
  login: sdk.login.bind(sdk),
  logout: sdk.logout.bind(sdk),
  onCallback: sdk.onCallback.bind(sdk),
  onChatCallback: sdk.onChatCallback.bind(sdk),
  destroy: sdk.destroy.bind(sdk),
}

if (typeof window !== 'undefined') {
  window.__AGENT_SDK__ = api
}

export const mount = api.mount
export const show = api.show
export const hide = api.hide
export const toggle = api.toggle
export const resize = api.resize
export const navigate = api.navigate
export const setExtData = api.setExtData
export const login = api.login
export const logout = api.logout
export const onCallback = api.onCallback
export const onChatCallback = api.onChatCallback
export const destroy = api.destroy

export { api, sdk, createSDK }
export default api